module.exports = __webpack_public_path__ + "static/media/review-cookie-bottom.40768041.png";